import script from "./DownloadReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadReport.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadReport.vue?vue&type=style&index=0&id=cbd71658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd71658"]])

export default __exports__